import React from "react";

import gql from "graphql-tag";
import { Query } from "@apollo/client/react/components";
import { client } from "../index";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

import LoggedInMenu from "./LoggedInMenu";
import OcrProcessDropzone from "./OcrProcessDropzone";
import UploaderButton from "./UploaderButton";
import SearchButton from "./SearchButton";

import LoadingView from "./LoadingView";
import ErrorView from "./ErrorView";
import { time } from "console";

const GET_BANK_STATEMENTS = gql`
  query clientBankStatements {
    clientBankStatements {
      url
      updatedAtTs
      startDateTs
      endDateTs
    }
  }
`;

const GET_ACCOUNT_BALANCE = gql`
  query clientAccountBalance {
    clientAccountBalance
  }
`;

function formatTimestamp(ts: number) {
  const d = new Date(ts * 1000);
  return d.toLocaleString("de-DE");
}

function timestampToMonth(ts: number) {
  const d = new Date(ts * 1000);
  const month = d.toLocaleString("de-DE", { month: "long" });
  return month + " " + d.getFullYear();
}

export interface IBankStatement {
  url: string;
  updatedAtTs: number;
  startDateTs: number;
  endDateTs: number;
}

export default class BankStatements extends React.Component {
  state: {
    bankStatements: Array<IBankStatement>;
    showModal: boolean;
  };

  constructor(props: any) {
    super(props);

    this.state = {
      bankStatements: [],
      showModal: false,
    };
  }

  render() {
    return (
      <div className="content-wrapper">
        <Container fluid>
          <Row>
            <Col xs={12} lg={10} className="main">
              <Container fluid>
                <Row className="pt-3 pb-1">
                  <Col xs={8}>
                    <h4 className="underline">Kontoauszüge</h4>
                  </Col>
                </Row>
              </Container>
              <div className="content-wrapper">
                <Query query={GET_ACCOUNT_BALANCE}>
                  {({ loading, error, data, refetch }: any) => {
                    if (loading) {
                      return <LoadingView />;
                    }

                    if (error) {
                      return <ErrorView error={error} />;
                    }

                    if (data.clientAccountBalance) {
                      return (
                        <p style={{ textAlign: "center" }}>
                          <h3>Aktueller Kontostand: </h3>
                          <h4>
                            {(data.clientAccountBalance / 100).toLocaleString(
                              "de-DE"
                            ) + " "}
                            EUR
                          </h4>
                        </p>
                      );
                    } else {
                      return (
                        <h5 style={{ textAlign: "center" }}>
                          Kein aktueller Kontostand vorhanden
                        </h5>
                      );
                    }
                  }}
                </Query>
                <div style={{ padding: "10px" }} />
                <Query query={GET_BANK_STATEMENTS} returnPartialData={true}>
                  {({ loading, error, data, refetch }: any) => {
                    if (loading) {
                      return <LoadingView />;
                    }

                    if (error) {
                      return <ErrorView error={error} />;
                    }

                    if ((data.clientBankStatements || []).length === 0) {
                      return (
                        <>
                          <p>Noch keine Kontoauszüge vorhanden.</p>
                          <p>
                            Kontoauszüge werden am 7. des Folgemonats
                            bereitgestellt.
                          </p>
                        </>
                      );
                    }

                    return (
                      <>
                        <p>
                          Kontoauszüge werden am 7. des Folgemonats
                          bereitgestellt.
                        </p>
                        <div
                          className="table-responsive"
                          style={{
                            borderStyle: "solid",
                            borderColor: "#dee2e6",
                            borderWidth: "1px 1px 1px 1px",
                            marginBottom: 100,
                            marginTop: 10,
                            padding: 10,
                          }}
                        >
                          <table className="table with-status table-sm table-hover middle">
                            <thead>
                              <tr>
                                <th>Zeitraum</th>
                                <th>Zuletzt aktualisiert</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {(data.clientBankStatements || []).map(
                                (m: any, idx: number) => (
                                  <tr key={idx}>
                                    <td>{timestampToMonth(m.startDateTs)}</td>
                                    <td>{formatTimestamp(m.updatedAtTs)}</td>
                                    <td>
                                      <a href={m.url} className="btn btn-link">
                                        Download
                                      </a>
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      </>
                    );
                  }}
                </Query>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
